import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dropdown from './dropdown';
import SearchDropdown from './searchDropdown';
import SearchInput from './searchInput';
import SimpleGrid from './simpleGrid';

import CSVUtil from '../../utils/csvUtil';
import HTMLUtil from '../../utils/htmlUtil';

const PREFIX_API = HTMLUtil.getPrefixAPI();

const LOCALES = {
    title: {
        ks: {
            fr: "Recherche par mot clé",
            en: "Search by keyword"
        },
        cs: {
            fr: "Recherche par code",
            en: "Search by code"
        },
        bl: {
            fr: "Recherche par liste",
            en: "Search by list"
        }
    },
    description: {
        ks: {
            "sh": {
                fr: "Inscrivez les mots clés pour le produit qui vous intéresse.",
                en: "Enter keywords for the product you are interested in."
            },
            "scian": {
                fr: "Inscrivez les mots clés pour l'industrie qui vous intéresse.",
                en: "Enter keywords for the industry you are interested in."
            },
            "cti": {
                fr: "Inscrivez les mots clés pour le niveau technologique qui vous intéresse.",
                en: "Enter keywords for the technological level you are interested in."
            }
        },
        cs: {
            "sh": {
                fr: "Inscrivez le code pour le produit qui vous intéresse.",
                en: "Enter code for the product you are interested in."
            },
            "scian": {
                fr: "Inscrivez le code pour l'industrie qui vous intéresse.",
                en: "Enter code for the industry you are interested in."
            },
            "cti": {
                fr: "Inscrivez le code pour le niveau technologique qui vous intéresse.",
                en: "Enter code for the technological level you are interested in."
            }
        },
        bl: {
            "sh": {
                fr: "Sélectionner une catégorie de produits et cliquer le bouton <b>Voir produits</b> pour voir tous les produits de la catégorie.",
                en: "Select a product category and press the <b>View Products</b> button to view all products for that category."
            },
            "scian": {
                fr: "Sélectionner une catégorie d'industrie et cliquer le bouton <b>Voir industries</b> pour voir toutes les industries de la catégorie.",
                en: "Select an industry category and press the <b>View industries</b> button to view all industries for that category."
            },
            "cti": {
                fr: "",
                en: ""
            }
        }
    },
    "results": {
        label: {
            fr: "Résultats",
            en: "Results"
        }
    },
    "selection": {
        label: {
            fr: "Sélection",
            en: "Selection"
        }
    },
    "no-results": {
        label: {
            fr: "Aucune correspondence.",
            en: "No results found."
        }
    },
    "too-much-results": {
        "label": {
            fr: "Trop de résultats... S'il vous plaît affiner vos critères de recherche.",
            en: "Too many results... Please narrow down your search criteria."
        }
    },
    "product-list": {
        "label": {
            "sh": {
                fr: "Catégories de produits",
                en: "Product categories"
            },
            "scian": {
                fr: "Catégories d'industries",
                en: "Industry categories"
            },
            "cti": {
                fr: "Choisir une ou plusieurs catégories de niveau technologique",
                en: "Select one or more technological level categories"
            }
        },
        "button": {
            "sh": {
                fr: "Voir produits",
                en: "View products"
            },
            "scian": {
                fr: "Voir industries",
                en: "View industries"
            },
            "cti": {
                fr: "Voir niveaux technologiques",
                en: "View technological levels"
            },
        }
    },
    "search-results": {
        "title": {
            fr: {
                s: "résultat pour",
                p: "résultats pour"
            },
            en: {
                s: "result for",
                p: "results for"
            }
        },
        "description": {
            fr: "Sélectionner un ou plusieurs produits et cliquer le bouton&nbsp;<b>Ajouter à la sélection</b>.",
            en: "Select one or more products and press the&nbsp;<b>Add to selected products</b>&nbsp;button."
        },
        "add-button": {
            fr: "Ajouter à la sélection",
            en: "Add to selected products"
        },
        "available": {
            fr: {
                s:"code disponible",
                p:"codes disponibles"
            },
            en: {
                s:"available code",
                p:"available codes"
            }
        },
        "note": {
            fr: "(NDA = non désigné ailleurs; A/Q = autre que)",
            en: "(NES = not elsewhere specified; O/T = other than)"
        }
    },
    "search-select": {
        "title": {
            "sh": {
                fr: {
                    s: "produit sélectionné",
                    p: "produits sélectionnés"
                },
                en: {
                    s: "selected product",
                    p: "selected products"
                }
            },
            "scian": {
                fr: {
                    s: "industrie sélectionnée",
                    p: "industries sélectionnées"
                },
                en: {
                    s: "selected industry",
                    p: "selected industries"
                }
            },
            "cti": {
                fr: {
                    s: "niveau technologique sélectionné",
                    p: "niveaux technologiques sélectionnés"
                },
                en: {
                    s: "selected technological level",
                    p: "selected technological levels"
                }
            }
            
        }
    },
    "show-mode": {
        "dataSource": {
            fr: [
                {
                    label: "Individuellement",
                    value: "INDIVIDUAL"
                },
                {
                    label: "Groupés",
                    value: "GROUPED"
                }
            ],
            en: [
                {
                    label: "Individually",
                    value: "INDIVIDUAL"
                },
                {
                    label: "Grouped",
                    value: "GROUPED"
                }
            ]
        },
        "label": {
            sh: {
                fr: "Présenter les produits",
                en: "Show products"
            },
            scian: {
                fr: "Présenter les industries",
                en: "Show industries"
            },
            cti: {
                fr: "Présenter les niveaux technologiques",
                en: "Show technological levels"
            }
        }
    }
}
const SCIAN_CODE_PARENT = {
    "31-33": [31,32,33],
    "44-45": [44,45]
}

const SH_CODE_PARENT = {
    "A": [1,2,3,4,5],
    "B": [6,7,8,9,10,11,12,13,14],
    "C": [15],
    "D": [16,17,18,19,20,21,22,23,24],
    "E": [25,26,27],
    "F": [28,29,30,31,32,33,34,35,36,37,38],
    "G": [39,40],
    "H": [41,42,43],
    "I": [44,45,46],
    "J": [47,48,49],
    "K": [50,51,52,53,54,55,56,57,58,59,60,61,62,63],
    "L": [64,65,66,67],
    "M": [68,69,70],
    "N": [71],
    "O": [72,73,74,75,76,77,78,79,80,81,82,83],
    "P": [84,85],
    "Q": [86,87,88,89],
    "R": [90,91,92],
    "S": [93],
    "T": [94,95,96],
    "U": [97]
};

class SearchPanel extends Component {
    constructor(props) {
        super(props);

        this._addSelectedValues = this._addSelectedValues.bind(this);
        this._removeSelectedValues = this._removeSelectedValues.bind(this);

        this._renderSearchResults = this._renderSearchResults.bind(this);
        this._renderSelectedResults = this._renderSelectedResults.bind(this);
        this._renderShowMode = this._renderShowMode.bind(this);

        this._getComerParamFromPage = this._getComerParamFromPage.bind(this);
        this._handleCtiListChange = this._handleCtiListChange.bind(this);
        this._searchHandler = this._searchHandler.bind(this);
        this._onProductListChangeHandler = this._onProductListChangeHandler.bind(this);
        this._onShowModeChangeHandler = this._onShowModeChangeHandler.bind(this);
        this._fetchProductList = this._fetchProductList.bind(this);
        this._fetchSearchResults = this._fetchSearchResults.bind(this);

        this.state = {
            searchInput: {
                value: "",
                data: []
            },
            tempSelectedValues: [],
            tempRemoveValues: [],
            searchResults: {
                data: [],
                total: null
            },
            selectedValues: {
                data: [],
                total: 0
            },
            "show-mode": {
                value: "INDIVIDUAL"
            }
        };
    }

    render() {
        return (
            <section className="panel-primary">
                <header className="panel-heading">
                    <h2 className="panel-title">{LOCALES["title"][this.props.type][this.props.lang]}</h2>
                </header>
                <div className="panel-body">
                    <p dangerouslySetInnerHTML={HTMLUtil.getHTMLTextForReact(LOCALES["description"][this.props.type][this.props.page][this.props.lang])}></p>
                    {
                        this._renderSearchInput()
                    }
                    {
                        this._renderSearchResults()
                    }
                    {
                        this._renderSelectedResults()
                    }
                    {
                        this._renderShowMode()
                    }
                </div>
            </section>
        );
    }
    componentDidMount() {
        if (this.props.type === "bl") {
            this._fetchProductList();
        }
    }

    componentDidUpdate(prevProps) {
        //Réinitialiser les valeurs si on change de type de recherche
        if (prevProps.type !== this.props.type)
        {
            this.setState(prevState => {
                return {
                    searchInput: {
                        value: "",
                        data: []
                    },
                    tempSelectedValues: [],
                    tempRemoveValues: [],
                    searchResults: {
                        data: [],
                        total: null
                    }
                }
            },() => {
                if (this.props.type.toLowerCase() === "bl") {
                    this._fetchProductList();
                }
            });
        }
    }

    _showModal(title, url) {
        this.props.showModal(title, url);
    }

    _onProductListChangeHandler(id,value)
    {
        this._searchHandler(value);
    }
    
    _getComerParamFromPage(page) {
        let currentPage = page || this.props.page;
        return {
            "sh-sh":"sh",
            "scian":"scian"
        }[currentPage] || currentPage;
    }
    _searchHandler(value) {
        //Recherche par mot-cle
        if (this.props.type === 'ks')
        {
            this._fetchSearchResults(`${PREFIX_API}hkc_api_web.p_retrn_rechr_mot?p_lang=${this.props.lang}&p_comer=${this._getComerParamFromPage()}&p_mot=`,value);
        }
        //Recherche par code
        else if (this.props.type === 'cs')
        {
            this._fetchSearchResults(`${PREFIX_API}hkc_api_web.p_retrn_rechr_code?p_lang=${this.props.lang}&p_comer=${this._getComerParamFromPage()}&p_code=`,value);
        }
        //Recherche par liste
        else if (this.props.type === 'bl')
        {
            this._fetchSearchResults(`${PREFIX_API}hkc_api_web.p_retrn_liste_detail?p_lang=${this.props.lang}&p_comer=${this._getComerParamFromPage()}&p_niv_sup=`,value)
        }
    }

    _productCellTemplate(col,dataItem) {
        let indent = (dataItem.indent ? dataItem.indent + 'px':'');

        return (
            <div style={{display:"flex",paddingLeft:indent}}>
                <div style={{marginRight:"10px"}} className="text-nowrap">{dataItem.code !== "0"?dataItem.code:""}</div>
                <div style={{width:"100%"}}>{dataItem.label}</div>
            </div>
        );
    }

    _renderSearchInput() {
        let elem = null;
        //Recherche par code ou mot-cle
        if (this.props.type === 'ks' || this.props.type === 'cs')
        {
            elem = <SearchInput focusOnInit={true} lang={this.props.lang} onSearch={this._searchHandler} format={this.props.type === 'cs'?'number':'text'} />
        }
        //Recherche par liste SH ou SCIAN
        else if (this.props.type === 'bl' && (this.props.page === 'sh' || this.props.page === 'scian'))
        {
            elem = <SearchDropdown id="productList" name="productList" lang={this.props.lang} isMulti={false} label={LOCALES["product-list"].label[this.props.page][this.props.lang]} buttonLabel={LOCALES["product-list"].button[this.props.page][this.props.lang]} onSearch={this._searchHandler} value={this.state.searchInput.value} dataSource={this.state.searchInput.data} />
        }
        //Recherche par liste CTI
        else if (this.props.type === 'bl' && this.props.page === 'cti' )
        {
            elem = <div className="form-group">
                <label htmlFor="currency" className="col-sm-3 control-label">
                    <span className="field-name">{LOCALES["product-list"].label[this.props.page][this.props.lang]}</span>
                </label>
                <div className="col-sm-9">
                    <Dropdown id="tech-level-list" name="tech-level-list" lang={this.props.lang} size={10} isMulti={true} onChange={this._handleCtiListChange} value={this.state.searchInput.value} dataSource={this.state.searchInput.data} />
                </div>
            </div>
        }

        return elem;
    }

    _renderSearchResults() {
        //Si total a une valeur, c'est qu'il y a eu un retour positif de l'API au moins une fois
        if (this.state.searchResults.total !== null)
        {
            let searchResults;
            if (this.state.searchResults.total > 1500)
            {
                searchResults = <p className="small">{LOCALES["too-much-results"].label[this.props.lang]}</p>
            }
            //Si Résultats === 0, on affiche un message aucun resultat
            else if (this.state.searchResults.total === 0)
            {
                searchResults = (
                    <div>
                        <p className="small">{LOCALES["no-results"].label[this.props.lang]}</p>
                    </div>
                );
            }
            //Si résultats > 0 on affiche le tableau de résultats
            else if (this.state.searchResults.total > 0) 
            {
                let columnsConfig = [
                    {
                        title: `${LOCALES.results.label[this.props.lang]} : ${this.state.searchResults.total}`,
                        field: "label",
                        template: this._productCellTemplate.bind(this)
                    }
                ];
                /*
                let sortConfig = [
                    {
                        field:"code", dir:"asc"
                    }
                ];
                */

                let selectableIds = this._getAvailableProductsCodes(this.state.searchResults.data.map((item) => item.value), this.state.tempSelectedValues);
                let filteredProductIds = this._getAvailableProductsCodes(this.state.searchResults.data.map((item) => item.value), this.state.selectedValues.data.map(item => item.value),false);
                
                searchResults = (
                    <div>
                        <div className="alert alert-info">
                            <div className="alert-content">
                                <p dangerouslySetInnerHTML={HTMLUtil.getHTMLTextForReact(LOCALES["search-results"]["description"][this.props.lang])}></p>
                            </div>
                        </div>
                        <h4>{filteredProductIds.length.toLocaleString(`${this.props.lang}-CA`)}&nbsp;{LOCALES["search-results"]["available"][this.props.lang][(filteredProductIds.length>1?'p':'s')]}</h4>                    
                                <div>
                                    <SimpleGrid id="selectableGrid"
                                        idField="value"
                                        lang={this.props.lang}
                                        selectable={true}
                                        wrapperStyles={{maxHeight:400}}
                                        headerVisible={false}
                                        enabledIds={selectableIds}
                                        selectedIds={this.state.tempSelectedValues}
                                        columns={columnsConfig}
                                        dataSource={this._getSearchedProductsFromCodes(filteredProductIds)}
                                        //sort={sortConfig}
                                        onSelectionChange={this._selectionGridChange.bind(this,'add')} />
                                    <p className="small pad-t-10">{LOCALES["search-results"]["note"][this.props.lang]}</p>
                                    <button className={((this.state.tempSelectedValues.length === 0)?"disabled ":"") + "btn btn-primary marg-t-15"} onClick={this._addSelectedValues}>{LOCALES["search-results"]["add-button"][this.props.lang]}</button>
                                </div>
                    </div>
                );
            }

            return (
                <div className="searchResults">
                    {
                        this._getSearchResultText()
                    }
                    {
                        searchResults
                    }
                </div>
            );
        }
    }

    _getSearchResultText() {
        if (this.props.type !== "bl") {
            return (
                <h3>
                    {this.state["searchResults"].total.toLocaleString(`${this.props.lang}-CA`)}&nbsp;{LOCALES["search-results"]["title"][this.props.lang][(this.state["searchResults"].total > 1?'p':'s')]}&nbsp;<em>{this.state["searchInput"].value}</em>
                </h3>
            )
        }
    }
    
    _renderSelectedResults() {
        if (this.state.selectedValues.total > 0)
        {
            let columnsConfig = [
                {
                    title: `${LOCALES.selection.label[this.props.lang]}&nbsp;:&nbsp;${this.state.selectedValues.total}`,
                    field: "label",
                    template: this._productCellTemplate.bind(this)
                }
            ];

            let sortConfig = [
                {
                    field:"code", dir:"asc"
                },
                {
                    field:"value", dir:"asc"
                }
            ];

            return (
                <div className="selectedResults marg-t-15">
                    <h3>{this.state.selectedValues.data.length.toLocaleString(`${this.props.lang}-CA`)}&nbsp;{LOCALES["search-select"]["title"][this.props.page][this.props.lang][this.state.selectedValues.data.length>1?'p':'s']}</h3>
                    <SimpleGrid id="selectedGrid"
                                idField="value"
                                lang={this.props.lang}
                                selectable={true}
                                selectedIds={this.state.tempRemoveValues}
                                headerVisible={false}
                                wrapperStyles={{maxHeight:400}}
                                columns={columnsConfig}
                                sort={sortConfig}
                                dataSource={this.state.selectedValues.data}
                                onSelectionChange={this._selectionGridChange.bind(this,'remove')} />
                    
                    <button className={((this.state.tempRemoveValues.length === 0)?"disabled ":"") + "btn btn-default marg-t-15"} onClick={this._removeSelectedValues}>Supprimer</button>
                </div>
            );
        }
    }

    _renderShowMode() {
        if (this.state["selectedValues"].data.length > 0 || this.props.page === 'cti')
        {
            return (
                <div className="form-group" style={{borderTop:"1px solid #CCC", marginTop:"10px", paddingTop: "10px"}}>
                    <label htmlFor="currency" className="col-sm-3 control-label">
                        <span className="field-name">{LOCALES["show-mode"].label[this.props.page][this.props.lang]}</span>
                    </label>
                    <div className="col-sm-9">
                        <Dropdown id="show-mode" lang={this.props.lang} value={this.state["show-mode"]||"INDIVIDUAL"} dataSource={LOCALES["show-mode"].dataSource[this.props.lang]} onChange={this._onShowModeChangeHandler} />
                    </div>
                </div>
            );
        } 
    }

    _handleCtiListChange(el,values) {
        
        this.setState(prevState => {
            return {"searchInput": Object.assign({},prevState.searchInput,{value: values||[]})}
        }, () => {
            this._bubbleSelections(this.state.searchInput.value);
        })
        
    }
    /**
     * Retourne un Array<string> des codes sélectionnables dans "allProducts" selon ce qui a déjà été sélectionné "selectedProducts"
     * Ex: Si 821 est selected, 82111 n'est pas disponible et 82 n'est pas disponible.
     * @param {Array<string>}   allProducts         Array des codes de produits recherchés
     * @param {Array<string>}   selectedProducts    Array des codes sélectionnées
     * @param {Boolean}         selectedIsAvailable Considere-t-on un element coché comme étant disponible ? (Par defaut: true, utile pour le "grisage" dans la selection de produits)
     * @returns {Array<string>}
     */
    _getAvailableProductsCodes(allProducts,selectedProducts, selectedIsAvailable) {

        selectedIsAvailable = (selectedIsAvailable === false)?false:true;

        return allProducts.filter((product) => {
            let isAvailable = true;

            for(let i = 0; i < selectedProducts.length; i++)
            {
                let selectedProduct = selectedProducts[i].toString();
                if (selectedProduct === product)
                {
                    isAvailable = selectedIsAvailable;
                }
                //SI CODE SH a valider === A, B, C,... OU CODE SCIAN a valider = 31-33 | 44-45
                else if (isNaN(Number(product.toString())))
                {
                    if (this.props.page.toLowerCase() === 'sh')
                    {
                        if (SH_CODE_PARENT[product.toString().toUpperCase()].filter(childCode => {
                            let prodToCompare = ((selectedProduct.length%2 > 0)?'0':'') + selectedProduct.toString();
                            return prodToCompare.startsWith(childCode.toString().padStart(2,"0"))
                        }).length > 0)
                        {
                            isAvailable = false;
                            break;
                        }
                    }
                    else if (this.props.page.toLowerCase() === 'scian')
                    {
                        if (SCIAN_CODE_PARENT[product.toString().toUpperCase()].filter(childCode => {
                            let prodToCompare = selectedProduct.toString();
                            return prodToCompare.startsWith(childCode.toString());
                        }).length > 0)
                        {
                            isAvailable = false;
                            break;
                        }
                    }
                }
                //SI CODE SH sélectionné === A, B, C,... OU CODE SCIAN selectionne = 31-33 | 44-45
                else if (isNaN(Number(selectedProduct.toString())))
                {
                    if (this.props.page.toLowerCase() === 'sh')
                    {
                        if (SH_CODE_PARENT[selectedProduct.toString().toUpperCase()].filter(childCode => {
                            let prodToCompare = ((product.length%2 > 0)?'0':'') + product.toString();
                            return prodToCompare.startsWith(childCode.toString().padStart(2,"0"));
                        }).length > 0)
                        {
                            isAvailable = false;
                            break;
                        }
                    }
                    else if (this.props.page.toLowerCase() === 'scian')
                    {
                        if (SCIAN_CODE_PARENT[selectedProduct.toString().toUpperCase()].filter(childCode => {
                            let prodToCompare = product.toString();
                            return prodToCompare.startsWith(childCode.toString());
                        }).length > 0)
                        {
                            isAvailable = false;
                            break;
                        }
                    }
                }
                //Code sélectionné est le début du code à valider OU vice-versa
                else if (
                    (selectedProduct.toString().startsWith(product) || product.toString().startsWith(selectedProduct))
                )
                {
                    isAvailable = false;
                    break;
                }
            }
            return isAvailable;
        },this);
    }

    /**
     * Retourne un Array<Object> qui correspond aux codes de produits demandés en paramètres.
     * @param {Array<string>} products Array des codes demandés
     * @returns {Array<object>}
     */
    _getSearchedProductsFromCodes(products) {
        return this.state.searchResults.data.filter((product) => (products.indexOf(product.value) >= 0)).map((item) => Object.assign({},item));
    }

    _selectionGridChange(type,values,toAdd) {
        let stateFieldToChange = "";
        if (type === 'add')
        {
            stateFieldToChange = "tempSelectedValues";
        }
        else if (type === 'remove') 
        {
            stateFieldToChange = "tempRemoveValues";
        }

        this.setState((prevState) => {
            let checkedVals = prevState[stateFieldToChange];
            let indexVal = checkedVals.indexOf(values);

            //À supprimer du tableau d'éléments cochés
            if (toAdd === false && indexVal >= 0) 
            {
                checkedVals.splice(indexVal,1);
                return {[stateFieldToChange]: checkedVals};
            }
            else if (toAdd === true && indexVal === -1) //À ajouter si pas déjà présent
            {
                checkedVals.push(values);
                return {[stateFieldToChange]: checkedVals};
            }
            
        });
    }

    _addSelectedValues(e) {
        e.preventDefault();

        if (this.state.tempSelectedValues.length > 0)
        {  
            //Sélectionner les produits qui sont cochés dans le tableau de résultats de recherche
            let newSelectedData = this.state.searchResults.data.filter((item) => (this.state.tempSelectedValues.indexOf(item.value) >= 0)).map((item) => Object.assign({},item));

            //Ajouter les nouveaux produits au catalogue de selection actuel
            let allSelectedData = this.state.selectedValues.data.concat(newSelectedData).map((item) => Object.assign({},item));
            
            this.setState((prevState) => {
                return {
                    tempSelectedValues: [],
                    selectedValues: {
                        data: allSelectedData,
                        total: allSelectedData.length
                    }
                };
            }, () => this._bubbleSelections(this.state.selectedValues.data.map(elem => elem.value)));
        }
    }

    _removeSelectedValues(e) {
        e.preventDefault();

        if (this.state.tempRemoveValues.length > 0)
        {
            //Garder les produits qui n'ont pas été cochés !
            let keptValues = this.state.selectedValues.data.filter((item) => (this.state.tempRemoveValues.indexOf(item.value) === -1));

            this.setState((prevState) => {
                return {
                    tempRemoveValues: [],
                    selectedValues: {
                        data: keptValues,
                        total: keptValues.length
                    }
                };
            },() => this._bubbleSelections(this.state.selectedValues.data.map(elem => elem.value)));
        }
    }

    _bubbleSelections(values) {
        if (this.props.onSelectChange)
        {
            this.props.onSelectChange(values||[]);
        }
        
    }

    _onShowModeChangeHandler(el,value,label) {
        this.setState(prevState => {
            return {
                "show-mode": value
            }
        },() => {
            if (this.props.onShowModeChange)
            {
                this.props.onShowModeChange(this.state["show-mode"]);
            }
        });
    }
    
    _fetchProductList() {
        fetch(`${PREFIX_API}hkc_api_web.p_retrn_liste_niv_sup?p_lang=${this.props.lang}&p_comer=${this._getComerParamFromPage()}`)
        .then(resp => {
            if (resp.status >= 200 && resp.status < 400)
            {
                return resp.text();
            }
            else
            {
                return "";
            }
        })
        .then(data => {
            let dataParsed = CSVUtil.csvToJSON(data);
            if (dataParsed.length > 0)
            {
                this.setState(prevState => {
                    return {
                        "searchInput": {
                            "value": dataParsed[0].value,
                            "data": dataParsed
                        }
                    };
                });
            }
        })
        .catch((error) => {
            console.error("Problèmes: fetchProductList", error)
        });
    }

    _fetchSearchResults(url,valueToSearch) {
        fetch(url + encodeURIComponent(valueToSearch))
        .then(resp => {
            if (resp.status >= 200 && resp.status < 400)
            {
                return resp.text();
            }
            else
            {
                return "";
            }
        })
        .then(data => {
            let dataParsed = CSVUtil.csvToJSON(data);

            this.setState(prevState => {
                return {
                    "searchInput": {
                        "value":valueToSearch,
                        "data": prevState.searchInput.data
                    },
                    "tempSelectedValues": [],
                    "searchResults": {
                        data: dataParsed,
                        total: dataParsed.length
                    }
                };
            });
        })
        .catch((error) => {
            console.error("Problèmes: fetchSearchResults", error)
        });
    }
}

SearchPanel.propTypes = {
    type: PropTypes.string.isRequired,
    lang: PropTypes.oneOf(["fr","en"]),
    page: PropTypes.oneOf(["sh","scian","cti"]),
    onSelectChange: PropTypes.func
};

export default SearchPanel;